import React, { useState, useEffect } from 'react';

function Header() {

  return (
    <div id="Header">
      <img src="https://www.flaticon.com/svg/static/icons/svg/66/66165.svg"></img>
      <h1>LJ Pomodoro Timer</h1>
    </div>

  )

}

export default Header
